/* eslint-disable */
import messageTypes from '@ringcentral-integration/commons/enums/messageTypes';
export default {
  addLog: 'Registro',
  editLog: 'Modifica registro',
  viewDetails: 'Visualizza dettagli',
  addEntity: 'Crea nuovo',
  call: 'Chiamata',
  text: 'SMS',
  conversation: 'Conversazione',
  groupConversation: 'Conversazione di gruppo',
  voiceMessage: 'Messaggio vocale',
  [messageTypes.voiceMail]: 'Segreteria telefonica',
  [messageTypes.fax]: 'Fax',
  mark: 'Segna come non letto',
  unmark: 'Contrassegna come letto',
  delete: 'Elimina',
  faxSent: 'Fax inviato',
  faxReceived: 'Fax ricevuto',
  pages: ' pagine',
  page: 'pagina',
  preview: 'Visualizza',
  download: 'Scarica',
  mmsWithOneAttachment: 'MMS con 1 allegato',
  mmsWithAttachments: 'MMS con {count} allegati',
} as const;

// @key: @#@"addLog"@#@ @source: @#@"Log"@#@
// @key: @#@"editLog"@#@ @source: @#@"Edit Log"@#@
// @key: @#@"viewDetails"@#@ @source: @#@"View Details"@#@
// @key: @#@"addEntity"@#@ @source: @#@"Create New"@#@
// @key: @#@"call"@#@ @source: @#@"Call"@#@
// @key: @#@"text"@#@ @source: @#@"Text"@#@
// @key: @#@"conversation"@#@ @source: @#@"Conversation"@#@
// @key: @#@"groupConversation"@#@ @source: @#@"Group Conversation"@#@
// @key: @#@"voiceMessage"@#@ @source: @#@"Voice message"@#@
// @key: @#@"[messageTypes.voiceMail]"@#@ @source: @#@"Voice Mail"@#@
// @key: @#@"[messageTypes.fax]"@#@ @source: @#@"Fax"@#@
// @key: @#@"mark"@#@ @source: @#@"Mark as Unread"@#@
// @key: @#@"unmark"@#@ @source: @#@"Mark as Read"@#@
// @key: @#@"delete"@#@ @source: @#@"Delete"@#@
// @key: @#@"faxSent"@#@ @source: @#@"Fax sent"@#@
// @key: @#@"faxReceived"@#@ @source: @#@"Fax received"@#@
// @key: @#@"pages"@#@ @source: @#@"pages"@#@
// @key: @#@"page"@#@ @source: @#@"page"@#@
// @key: @#@"preview"@#@ @source: @#@"View"@#@
// @key: @#@"download"@#@ @source: @#@"Download"@#@
// @key: @#@"mmsWithOneAttachment"@#@ @source: @#@"MMS with 1 attachment"@#@
// @key: @#@"mmsWithAttachments"@#@ @source: @#@"MMS with {count} attachments"@#@
